/**
 * Simple EventEmitter implementation for browser environments
 */

type EventListener = (...args: unknown[]) => void

export class EventEmitter {
  private events: Map<string, Set<EventListener>> = new Map()

  on(event: string, listener: EventListener): void {
    if (!this.events.has(event)) {
      this.events.set(event, new Set())
    }
    this.events.get(event)!.add(listener)
  }

  off(event: string, listener: EventListener): void {
    const listeners = this.events.get(event)
    if (listeners) {
      listeners.delete(listener)
      if (listeners.size === 0) {
        this.events.delete(event)
      }
    }
  }

  emit(event: string, ...args: unknown[]): void {
    const listeners = this.events.get(event)
    if (listeners) {
      listeners.forEach((listener) => {
        try {
          listener(...args)
        } catch {
          // console.error(`Error in event listener for ${event}:`, error);
        }
      })
    }
  }

  removeAllListeners(event?: string): void {
    if (event) {
      this.events.delete(event)
    } else {
      this.events.clear()
    }
  }

  listenerCount(event: string): number {
    const listeners = this.events.get(event)
    return listeners ? listeners.size : 0
  }
}
